"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['just nu', 'om en stund'],
        ['%s sekunder sedan', 'om %s sekunder'],
        ['1 minut sedan', 'om 1 minut'],
        ['%s minuter sedan', 'om %s minuter'],
        ['1 timme sedan', 'om 1 timme'],
        ['%s timmar sedan', 'om %s timmar'],
        ['1 dag sedan', 'om 1 dag'],
        ['%s dagar sedan', 'om %s dagar'],
        ['1 vecka sedan', 'om 1 vecka'],
        ['%s veckor sedan', 'om %s veckor'],
        ['1 månad sedan', 'om 1 månad'],
        ['%s månader sedan', 'om %s månader'],
        ['1 år sedan', 'om 1 år'],
        ['%s år sedan', 'om %s år'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=sv.js.map